import React from 'react'
import { Row } from 'antd';
import BuyNftDetails from '../../Components/Nft/BuyNftDetails'
import BackButton from '../../Components/Nft/BackButton'
import './NftListing.css'

function BuyNft() {
    return (
        <div className="container">
            <Row className='mt-5'>
                <BackButton />
            </Row>

            <BuyNftDetails />

        </div>
    )
}

export default BuyNft